const partnerConfig = {
  legacy: {
    providedLabel: 'Send to funeral home',
    customLabel: 'Send to family address',
    showCareOf: true,
  },
  tukios: {
    providedLabel: 'Send to family home',
    customLabel: 'Send to other address',
    showCareOf: false,
  },
}

export default partnerConfig
